export const history = {
    navigate: null,
    location: null,
    params: null
}
